// extracted by mini-css-extract-plugin
module.exports = {"root":"ImageDisplay__root--2pd1K","isActive":"ImageDisplay__isActive--3C6SD"};